import loadable from '@loadable/component';

export const CourseDetailsPage = loadable(/* #__LOADABLE__ */ () => import('./CourseDetailsPage'));
